import config from 'config'
import { Entitlements } from 'types/Entitlements'
import { fetchWithToken } from 'utils'
import externalAdminFiltersToString from './externalAdminFiltersToString'

export interface LicensesDetails {
  products: string[]
  entitlements: Entitlements
  results?: License[]
  isLoaded: boolean
}

export interface License {
  key: string
  seats: number
  userCount: number
  description: string
  enabled?: boolean
  type?: string
  channel?: string
  userKeys?: string[]
  childLicenseKeys?: string[]
  invitedUserKeys?: string[]
  deviceCount?: number
  products?: string[]
  entitlements?: Entitlements
  devicesOnly?: boolean
  externallyManaged?: boolean
  deviceKeys?: string[]
}

/**
 * Retrieves the account entitlements from licenses
 */
const fetchLicensesDetails = async (accountKey: string): Promise<LicensesDetails> =>
  await fetchWithToken({
    method: 'GET',
    useV5: false,
    useVersion: '',
    baseUrl: config.EXTERNAL_ADMIN_URL,
    resource: `ext-admin/rest/accounts/${accountKey}`,
    path: 'licenses',
    filters: externalAdminFiltersToString({ filter: '((enabled eq "true"))' }),
  })
    .then((response: Response) => response.json())
    .then((licenses) => {
      const products: string[] = []
      const entitlements =
        licenses.results?.reduce((entitlements, license) => {
          // compute products
          products.push(...(license.products || []).filter((product) => !products.includes(product)))

          // compute entitlements
          if (license.entitlements) {
            Object.keys(license.entitlements).forEach((entitlement) => {
              entitlements[entitlement] = entitlements[entitlement] || {}

              Object.keys(license.entitlements[entitlement]).forEach((entitlementSetting) => {
                const settingValue = license.entitlements[entitlement][entitlementSetting]

                // only add truthy values
                if (settingValue) {
                  entitlements[entitlement][entitlementSetting] = settingValue
                }
              })
            })
          }

          return entitlements
        }, {}) || {}
      return { products, entitlements, ...licenses }
    })
    .catch((err: Error) => {
      // Something wrong happened during the fetch
      console.error(err.toString())
    })

export default fetchLicensesDetails
